import React, { FC } from "react";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import AttachmentsCard from "../../../../../../../../../../components/Attachment/AttachmentsCard";
import { StockAdjustmentApi } from "../../../../../../../../../../services/Api/Organization/types";
import StockAdjustmentBasicInfoCard from "../StockAdjustmentPreview/StockAdjustmentBasicInfoCard";
import StockAdjustmentItemsCard from "../StockAdjustmentPreview/StockAdjustmentItemsCard";

interface Props {
	stockAdjustment: StockAdjustmentApi;
	fetchStockAdjustment: () => void;
	customFieldsConfig?: CustomFieldTemplateApi[];
}

const StockAdjustmentPreviewTab: FC<Props> = ({ stockAdjustment, fetchStockAdjustment, customFieldsConfig }) => {
	return (
		<div className="col px-0">
			<StockAdjustmentBasicInfoCard stockAdjustment={stockAdjustment} customFieldsConfig={customFieldsConfig} />
			{stockAdjustment?.items?.length > 0 && (
				<StockAdjustmentItemsCard
					stockAdjustment={stockAdjustment}
					fetchStockAdjustment={fetchStockAdjustment}
				/>
			)}
			{stockAdjustment?.file_attachments?.length > 0 && (
				<AttachmentsCard attachments={stockAdjustment.file_attachments} />
			)}
		</div>
	);
};

export default StockAdjustmentPreviewTab;
